module.exports = __webpack_public_path__ + "static/media/4.8562d8bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/carousel/4.png
// module id = 402
// module chunks = 0